interface DiscoverIconProps {
  size?: number;
  className?: string;
}

const DiscoverIcon: React.FC<DiscoverIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <rect
        className="discoverWand"
        x="2.1"
        y="11.6"
        width="8.2"
        height="2"
        rx="1"
        transform="rotate(-45 2.1 11.6)"
        fill="currentColor"
      />
      <path
        className="discoverSpark discoverSpark1"
        d="M10.6 2.1L11.1 3.5L12.5 4L11.1 4.5L10.6 5.9L10.1 4.5L8.7 4L10.1 3.5L10.6 2.1Z"
        fill="currentColor"
      />
      <path
        className="discoverSpark discoverSpark2"
        d="M13.3 6.2L13.62 7.08L14.5 7.4L13.62 7.72L13.3 8.6L12.98 7.72L12.1 7.4L12.98 7.08L13.3 6.2Z"
        fill="currentColor"
        opacity="0.85"
      />
      <path
        className="discoverSpark discoverSpark3"
        d="M7.2 1.6L7.48 2.36L8.24 2.64L7.48 2.92L7.2 3.68L6.92 2.92L6.16 2.64L6.92 2.36L7.2 1.6Z"
        fill="currentColor"
        opacity="0.8"
      />
      <circle className="discoverSpark discoverSpark4" cx="12.7" cy="5.2" r="0.5" fill="currentColor" opacity="0.9" />
      <circle className="discoverSpark discoverSpark5" cx="9.5" cy="5.1" r="0.45" fill="currentColor" opacity="0.9" />
    </svg>
  );
};

export default DiscoverIcon;
